export default __webpack_public_path__ + "static/media/footer-bg.99c3d0b3.png";